"use strict";
exports.__esModule = true;
exports.activationFees = exports.oneTrx = void 0;
var bignumber_js_1 = require("bignumber.js");
exports.oneTrx = new bignumber_js_1.BigNumber(1000000);
exports.activationFees = new bignumber_js_1.BigNumber(1000000);
//# sourceMappingURL=constants.js.map